export class SetLoading {
  static readonly type = '[UI] SetLoading]';
  constructor(
    public readonly loading: boolean,
    public readonly yProgress?: number
  ) { }
}